import * as React from 'react';
import { connect } from 'react-redux';
import { withNavigation } from '../General/withNavigation';
import {
  fetchSeller,
  editSeller,
  fetchIntegradores,
  fetchFacturaciones
} from '../../actions/sellersActions';
import TiposParaGuardar from './TipoPublicaciones/TiposParaGuardar';
import PropTypes from 'prop-types';
import { selectSellerMerged } from '../../helper/sellerMergedSelector';

class Publicacion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      didEdit: false,
      checked: 0,
      listaIdTiposPublicaciones: []
    };
  }

  componentDidMount() {
    this.props.fetchFacturaciones();
  }

  myChangeHandler = (event) => {
    this.setState({ didEdit: true });
    const { name, value } = event.target;

    const seller = { ...(this.props.seller || {}) };

    if (name === 'tipoFacturacion') {
      if (value === '') {
        seller.tipoFacturacion = null;
      } else {
        const found = (this.props.facturaciones || []).find(
          (f) => String(f.codigo) === String(value)
        );
        if (found) seller.tipoFacturacion = { ...found };
        else {
          const num = Number(value);
          seller.tipoFacturacion = Number.isNaN(num) ? value : num;
        }
      }
    } else {
      seller[name] = value;
    }

    this.props.editSeller(seller);
  };

  onSelectTipoPublicacion = () => {
    this.props.navigate('/Sellers/TiposPublicaciones/Select');
  };

  render() {
    const { isCategory, isAdminMod } = this.props.userType || {};
    const seller = this.props.seller || {};

    const facturaciones = (this.props.facturaciones || []).map((item) => (
      <option key={item.codigo} value={String(item.codigo)}>
        {item.descripcion}
      </option>
    ));

    const tipoFacturacionValue = String(
      seller?.tipoFacturacion?.codigo ??
      seller?.tipoFacturacion?.idTipoFacturacion ??
      seller?.tipoFacturacion ??
      ''
    );

    return (
      <div className="tab-pane p-20 active" name="datos" id="home2" role="tabpanel">
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-6">
            <div className="form-group">
              <label htmlFor="inlineFormCustomSelect">Tipo de Facturación</label>
              <select
                disabled={!isAdminMod}
                className="form-control"
                value={tipoFacturacionValue}
                onChange={this.myChangeHandler}
                id="inlineFormCustomSelect"
                name="tipoFacturacion"
              >
                {facturaciones}
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="urlPushOrdenes">URL push ordenes</label>
              <input
                id="urlPushOrdenes"
                type="text"
                name="urlPushOrdenes"
                className="form-control"
                value={seller?.urlPushOrdenes || ''}
                onChange={this.myChangeHandler}
                disabled={!isCategory && !isAdminMod}
              />
            </div>
          </div>

          <div className="col-12 mt-3">
            <TiposParaGuardar history={this.props.history} />
            {(isCategory || isAdminMod) && (
              <button
                type="button"
                onClick={this.onSelectTipoPublicacion}
                className="btn btn-sm background-rojo-megatone waves-light m-t-15"
              >
                Seleccionar tipo de publicación
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

Publicacion.propTypes = {
  navigate: PropTypes.func,
  seller: PropTypes.shape({
    tipoFacturacion: PropTypes.oneOfType([
      PropTypes.shape({ codigo: PropTypes.number }),
      PropTypes.number
    ]),
    urlPushOrdenes: PropTypes.string
  }),
  userType: PropTypes.shape({ isCategory: PropTypes.bool, isAdminMod: PropTypes.bool }),
  facturaciones: PropTypes.array,
  history: PropTypes.object,
  fetchFacturaciones: PropTypes.func,
  editSeller: PropTypes.func
};

const mapStateToProps = (state) => ({
  userType: state.general.userType,
  seller: selectSellerMerged(state),
  facturaciones: state.sellers.facturaciones,
  integradores: state.sellers.integradores
});

export default withNavigation(
  connect(mapStateToProps, {
    fetchSeller,
    editSeller,
    fetchIntegradores,
    fetchFacturaciones
  })(Publicacion)
);